import { createFileRoute } from '@tanstack/react-router';
import TimeTracking from '../components/TimeTracking';

export const Route = createFileRoute('/time-entry')({
  component: TimeEntryComponent,
});

function TimeEntryComponent() {
  return <TimeTracking />;
}

